import type { UnknownObject } from '../../../types';
export type LoggingChannel =
  | 'firebase'
  | 'amplitude'
  | 'braze'
  | 'ablylog'
  | 'facebook'
  | 'airbridge'
  | 'ad';

export const LOG_ANALYTICS_ALL_CHANNELS: Array<LoggingChannel> = [
  'firebase',
  'amplitude',
  'braze',
  'ablylog',
  'facebook',
  'airbridge',
];
export type LogAnalyticsEventParams = {
  channel?: Array<LoggingChannel>;
  name: string;
  /**
   * - 키는 대문자, snake case로 작성합니다.
   * - SCREEN이 있는지 확인해주세요
   */
  analytics?: UnknownObject;
  ably_only_log?: UnknownObject;
  ignoreAblyLog?: boolean;
};
